import { render, staticRenderFns } from "./view-student-lists.vue?vue&type=template&id=2bda1cda&scoped=true&"
import script from "./view-student-lists.vue?vue&type=script&lang=js&"
export * from "./view-student-lists.vue?vue&type=script&lang=js&"
import style0 from "./view-student-lists.vue?vue&type=style&index=0&id=2bda1cda&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bda1cda",
  null
  
)

export default component.exports